import React from 'react';
import styled from 'styled-components';
import { Marginer } from "../marginer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";

const CardContainer = styled.div`
    display:flex;
    flex-direction: column;
    overflow:hidden;
    width: 300px;
    min-height: 250px;
    background-color:#fff;
    box-shadow: 0 0 2px rgba(0,0,0, 0.4);
    margin: 0.5em;
    margin-bottom:1.3em;
`;

const TopContainer = styled.div`
    width:100%;

`;

const ServiceThumbnail = styled.div`
    width:100%;
    height:11em;
    img {
        width:100%;
        height:100%;

    }
`;

const ContentContainer = styled.div`
    width:100%;
    display:flex;
    flex-wrap:wrap;
    flex-direction:column;
    align-items:flex-start;
    justify-content:space-between;
    flex:1;
    padding: 15px 14px;
`;

const BottomContainer = styled.div`
    width: 100%;
    height: 32px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    border-top: 1px solid rgba(15,15,15, 0.19);
    padding: 0 10px;
`;

const Title = styled.h2`
    font-size:19px;
    font-weight: 500;
    color: #000;
    margin:0;
`;

const SpecialistName = styled.h4`
    margin:0;
    color: rgba(151, 151, 151, 1);
    font-size:12px;
    font-weight:400;
`;

const RatingContainer = styled.div`
    display:flex;
    color: #EBE204;

`;

const PriceContainer = styled.div`
    display:flex;
    align-items:center;
`;

const PriceText = styled.div`
    margin-left:3px;
    color: #2ba679;
    font-weight:700;
`;

const StartingAt = styled.h6`
    margin:0;
    color: rgba(161, 161, 161, 0.9);
    font-weight:400;
`;

export function ServiceCard(props){
    const { thumbnailUrl, specialist, title, rate, rating } = props;

    return (
        <CardContainer>
        <TopContainer>
            <ServiceThumbnail>
                <img src={thumbnailUrl} alt={title}/>
            </ServiceThumbnail>
        </TopContainer>
        <ContentContainer>
            <Title>{title}</Title>
            <Marginer direction="vertical" margin={10}></Marginer>
            <SpecialistName>{specialist.fullName}</SpecialistName>
        </ContentContainer>
        <BottomContainer>
            <RatingContainer>
                <FontAwesomeIcon icon={faStar} size="sm" />
                {rating}
            </RatingContainer>
            <PriceContainer>
                <StartingAt>
                    STARTING AT
                </StartingAt>
                <PriceText>
                    ${rate}/hr
                </PriceText>
            </PriceContainer>
        </BottomContainer>
    </CardContainer>
    );
}